<template>
	<SharedDocumentTile :document-name="documentName" :is-pdf="isPdf" :file-extension-label="fileExtensionLabel" :selecting="selecting">
		<template #session-label><slot name="session-label" /></template>
	</SharedDocumentTile>
</template>

<script lang="ts" setup>
	import { computed, type PropType } from "vue";
	import SharedDocumentTile from "@common-ui/media/DocumentTile.vue";
	import type { IndexableDocument } from "@/types/search/IndexableDocument";
	import { getFileExtension } from "@/helpers/files";
	import { getTimelineDocumentName, isPdfTimelineDocument } from "@/helpers/timelineDocuments";

	// LSP-16659: a Files row shown in the Session / Project media grid. Tile only — click, selection and
	// the session link belong to Timeline, which owns them for every tile type.
	const props = defineProps({
		document: {
			type: Object as PropType<IndexableDocument>,
			required: true
		},
		selecting: {
			type: Boolean,
			default: false
		}
	});

	const documentName = computed(() => getTimelineDocumentName(props.document));
	const isPdf = computed(() => isPdfTimelineDocument(props.document));
	const fileExtensionLabel = computed(() => {
		const extension =
			getFileExtension({ name: props.document.fileName ?? props.document.name }) ||
			getFileExtension({ uploadResult: { key: props.document.mediaUrl ?? "" } });
		return extension ? extension.toUpperCase().slice(0, 5) : "";
	});
</script>
